import _ from "lodash";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchWorkedCandidates,
  updateFilters,
  showFilterModal,
  updatePagination,
  deSelectAllCandidate,
  setWorkedCandidatesLoading,
} from "@/reducers/client_candidates/candidatesworked";
import { getIsFilterApplied } from "@/utilities/utils";

import TableSearch from "../../../dataTables/TableSearch";
import FilterButton from "../../../ListingFilters/FilterButton";

/**
 * Function for rendering the search filter component.
 *
 * @return {JSX.Element} The search filter component
 */
export const SearchFilter = () => {
  const { filters, pagination, listView } = useSelector(
    (state) => state.clientCandidatesWorked,
  );
  let _filters = _.cloneDeep(filters);
  if (listView != "shifts") {
    delete _filters.timeSheetStatus;
  }
  const filterApplied = getIsFilterApplied(_filters);
  const dispatch = useDispatch();
  /**
   * Handles the search input and updates the filters.
   *
   * @param {Event} e - the event object
   * @return {void}
   */
  const handleSearch = (e) => {
    dispatch(updateFilters({ search: e.target.value }));
  };
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setWorkedCandidatesLoading(true));
      dispatch(
        updatePagination({
          ...pagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(deSelectAllCandidate());
      dispatch(fetchWorkedCandidates(filters));
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [filters.search]);

  return (
    <div className="SearchFilter_Wrapper">
      <div className="flex gap-[20px]">
        <TableSearch val={filters.search} handleChange={handleSearch} />
        <FilterButton
          filterApplied={filterApplied}
          handleClick={() => {
            dispatch(showFilterModal(true));
          }}
        />
      </div>
    </div>
  );
};
